var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "searchPanel" }, [
    _vm.filtro.simplificado
      ? _c("div", { key: "simpleSearch", staticClass: "simpleSearch" }, [
          _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.$emit("pesquisar", _vm.filtro)
                }
              }
            },
            [
              _c(
                "el-input",
                {
                  staticClass: "input input-with-select",
                  attrs: { placeholder: _vm.placeholder },
                  model: {
                    value: _vm.filtro.campoSimples,
                    callback: function($$v) {
                      _vm.$set(_vm.filtro, "campoSimples", $$v)
                    },
                    expression: "filtro.campoSimples"
                  }
                },
                [
                  _c("el-button", {
                    staticClass: "color-default",
                    attrs: {
                      slot: "append",
                      icon: "el-icon-search",
                      id: "botao-filtro-simplificado"
                    },
                    on: { click: _vm.pesquisar },
                    slot: "append"
                  })
                ],
                1
              )
            ],
            1
          )
        ])
      : _vm._e(),
    !_vm.filtro.simplificado
      ? _c("div", { staticClass: "advancedSearch" }, [
          _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.$emit("pesquisar", _vm.filtro)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "panel" },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { lg: 6, md: 12, sm: 24 } },
                        [
                          _c("p", { staticClass: "titulo" }, [
                            _vm._v("Processo:")
                          ]),
                          _c("el-input", {
                            model: {
                              value: _vm.filtro.numeroProcesso,
                              callback: function($$v) {
                                _vm.$set(_vm.filtro, "numeroProcesso", $$v)
                              },
                              expression: "filtro.numeroProcesso"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 6, md: 12, sm: 24 } },
                            [
                              _c("p", { staticClass: "titulo" }, [
                                _vm._v("CPF/CNPJ do Interessado:")
                              ]),
                              _c("el-input", {
                                directives: [
                                  {
                                    name: "mask",
                                    rawName: "v-mask",
                                    value: [
                                      "###.###.###-##",
                                      "##.###.###/####-##"
                                    ],
                                    expression:
                                      "['###.###.###-##', '##.###.###/####-##']"
                                  }
                                ],
                                staticClass: "input input-with-select",
                                model: {
                                  value: _vm.filtro.cpfCnpjInteressado,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.filtro,
                                      "cpfCnpjInteressado",
                                      $$v
                                    )
                                  },
                                  expression: "filtro.cpfCnpjInteressado"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { lg: 6, md: 12, sm: 24 } },
                            [
                              _c("p", { staticClass: "titulo" }, [
                                _vm._v("Nome/Razão Social do Interessado:")
                              ]),
                              _c("el-input", {
                                model: {
                                  value: _vm.filtro.nomeInteressado,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filtro, "nomeInteressado", $$v)
                                  },
                                  expression: "filtro.nomeInteressado"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { lg: 6, md: 12, sm: 24 } },
                            [
                              _c("p", { staticClass: "titulo" }, [
                                _vm._v("Áreas/Imóveis/Comunidades")
                              ]),
                              _c("el-input", {
                                model: {
                                  value: _vm.filtro.areaImovelComunidade,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.filtro,
                                      "areaImovelComunidade",
                                      $$v
                                    )
                                  },
                                  expression: "filtro.areaImovelComunidade"
                                }
                              })
                            ],
                            1
                          ),
                          _c("el-col", { attrs: { lg: 6, md: 12, sm: 24 } }, [
                            _c("p", { staticClass: "titulo" }, [
                              _vm._v("Tipo de processo:")
                            ]),
                            _c(
                              "div",
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "full-width",
                                    attrs: {
                                      placeholder: "Selecione",
                                      multiple: "multiple",
                                      clearable: "clearable"
                                    },
                                    model: {
                                      value: _vm.filtro.tipos,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filtro, "tipos", $$v)
                                      },
                                      expression: "filtro.tipos"
                                    }
                                  },
                                  _vm._l(_vm.tiposCadastroSelect, function(
                                    tipo
                                  ) {
                                    return _c("el-option", {
                                      key: tipo.codigo,
                                      attrs: {
                                        label: tipo.nome,
                                        value: tipo.codigo
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ]),
                          _c(
                            "el-col",
                            { attrs: { lg: 6, md: 12, sm: 24 } },
                            [
                              _c("p", { staticClass: "titulo" }, [
                                _vm._v("Município:")
                              ]),
                              _c(
                                "el-select",
                                {
                                  staticClass: "full-width",
                                  attrs: {
                                    multiple: "multiple",
                                    placeholder: "Selecione",
                                    clearable: "clearable",
                                    filterable: "filterable",
                                    "no-match-text": "Município não encontrado"
                                  },
                                  on: {
                                    clear: function($event) {
                                      _vm.filtro.municipios = null
                                    }
                                  },
                                  model: {
                                    value: _vm.filtro.municipios,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filtro, "municipios", $$v)
                                    },
                                    expression: "filtro.municipios"
                                  }
                                },
                                _vm._l(_vm.municipios, function(m) {
                                  return _c("el-option", {
                                    key: m.id,
                                    attrs: { label: m.nome, value: m.id }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { lg: 6, md: 12, sm: 24 } },
                            [
                              _c("p", { staticClass: "titulo" }, [
                                _vm._v("Status:")
                              ]),
                              _c(
                                "el-select",
                                {
                                  staticClass: "full-width",
                                  attrs: {
                                    placeholder: "Selecione",
                                    clearable: "clearable"
                                  },
                                  model: {
                                    value: _vm.filtro.status,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filtro, "status", $$v)
                                    },
                                    expression: "filtro.status"
                                  }
                                },
                                _vm._l(_vm.statusConflito, function(status) {
                                  return _c("el-option", {
                                    key: status.codigo,
                                    attrs: {
                                      label: status.descricao,
                                      value: status.codigo
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { lg: 6, md: 12, sm: 24 } },
                            [
                              _c("p", { staticClass: "titulo" }, [
                                _vm._v("Data de criação:")
                              ]),
                              _c(
                                "el-date-picker",
                                _vm._b(
                                  {
                                    staticClass: "full-width input date",
                                    attrs: {
                                      type: "daterange",
                                      "start-placeholder": "Período inicial",
                                      "end-placeholder": "Período Final",
                                      format: "dd/MM/yyyy",
                                      name: "data"
                                    },
                                    on: { change: _vm.ajustarData },
                                    model: {
                                      value: _vm.filtro.dataCriacao,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filtro, "dataCriacao", $$v)
                                      },
                                      expression: "filtro.dataCriacao"
                                    }
                                  },
                                  "el-date-picker",
                                  _vm.$attrs,
                                  false
                                )
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ])
      : _vm._e(),
    _c("div", { staticClass: "button-group" }, [
      _c(
        "div",
        { staticClass: "left-buttons" },
        [
          _vm.showPesquisaAvancada
            ? _c(
                "el-button",
                {
                  staticClass: "no-padding",
                  attrs: { type: "text" },
                  on: { click: _vm.changePesquisa }
                },
                [_vm._v(_vm._s(_vm.tituloPesquisa))]
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              staticClass: "no-padding",
              attrs: { type: "text" },
              on: { click: _vm.limpar }
            },
            [_vm._v("Limpar")]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "right-buttons" },
        [
          !_vm.filtro.simplificado
            ? _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { type: "primary", id: "botao-filtro-avancado" },
                  on: { click: _vm.pesquisar }
                },
                [
                  _c("i", { staticClass: "el-icon-search" }),
                  _vm._v("  Pesquisar")
                ]
              )
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-730ee012", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-730ee012","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/ouvidoria/Filtro.vue
// module id = null
// module chunks = 